/**
 * formats a string by replacing all %s with arguments
 * Example:
 *
 *  formatString("Hello %s", "World")
 *   => Hello World
 */
export function formatString() {
  let a;
  let b;
  let c;
  // biome-ignore lint/style/noArguments: <explanation>
  a = arguments[0];
  b = [];
  // biome-ignore lint/style/noArguments: <explanation>
  for (c = 1; c < arguments.length; c++) {
    // biome-ignore lint/style/noArguments: <explanation>
    b.push(arguments[c]);
  }
  for (c in b) {
    a = a.replace(/%[a-z]/, b[c]);
  }
  return a;
}
